var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileAktiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.0009C18.4188 16.0009 22 12.4189 22 8.00047C22 3.58208 18.4188 0 14 0C9.58125 0 6 3.58208 6 8.00047C6 12.4189 9.58125 16.0009 14 16.0009ZM17.1688 19.0011H10.8313C4.85063 19.0011 0 23.8514 0 29.833C0 31.0293 0.97 32 2.16625 32H25.835C27.0312 32.0019 28 31.0331 28 29.833C28 23.8514 23.15 19.0011 17.1688 19.0011Z",
    fill: "#FF5870"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAktiv);
export default __webpack_public_path__ + "static/media/profile-aktiv.5e7df35a78c231523b77eb2f6c3e25af.svg";
export { ForwardRef as ReactComponent };